const ROW_HEIGHT_COMFORTABLE = 48;
const ROW_HEIGHT_DEFAULT = 36;
const ROW_HEIGHT_COMPACT = 24;

const MIN_COL_WIDTH_COMFORTABLE = 150;
const MIN_COL_WIDTH_DEFAULT = 135;
const MIN_COL_WIDTH_COMPACT = 110;

const MIN_COL_BADGE_WIDTH_COMFORTABLE = 180;
const MIN_COL_BADGE_WIDTH_DEFAULT = 165;
const MIN_COL_BADGE_WIDTH_COMPACT = 150;

export const getDensityClass = (classes, node, density) => {
  const className = `${density}${node}`;
  return classes[className];
};

export const getMinColumnWidth = density => {
  switch (density) {
    case 'comfortable':
      return MIN_COL_WIDTH_COMFORTABLE;
    case 'default':
      return MIN_COL_WIDTH_DEFAULT;
    case 'compact':
      return MIN_COL_WIDTH_COMPACT;
    default:
      return {};
  }
};

export const getBadgeColumnWidth = density => {
  switch (density) {
    case 'comfortable':
      return MIN_COL_BADGE_WIDTH_COMFORTABLE;
    case 'default':
      return MIN_COL_BADGE_WIDTH_DEFAULT;
    case 'compact':
      return MIN_COL_BADGE_WIDTH_COMPACT;
    default:
      return {};
  }
};

export const getCheckboxWidth = density => {
  switch (density) {
    case 'comfortable':
      return { width: 128 };
    case 'default':
      return { width: 88 };
    case 'compact':
      return { width: 48 };
    default:
      return {};
  }
};

export const getRowHeight = density => {
  switch (density) {
    case 'comfortable':
      return ROW_HEIGHT_COMFORTABLE;
    case 'default':
      return ROW_HEIGHT_DEFAULT;
    case 'compact':
      return ROW_HEIGHT_COMPACT;
    default:
      return {};
  }
};

export const getFilterIconStyle = density => {
  switch (density) {
    case 'comfortable':
      return {
        paddingLeft: 14
      };
    case 'default':
      return {
        paddingLeft: 10
      };
    case 'compact':
      return {
        paddingLeft: 2
      };
    default:
      return { paddingLeft: 14 }
  }
};

export const density = {
  comfortableRow: {
    height: ROW_HEIGHT_COMFORTABLE
  },
  defaultRow: {
    height: ROW_HEIGHT_DEFAULT
  },
  compactRow: {
    height: ROW_HEIGHT_COMPACT
  },
  comfortableCheckbox: {
    height: '80%',
    width: '80%',
    padding: 0
  },
  defaultCheckbox: {
    height: '80%',
    width: '80%',
    padding: 0
  },
  compactCheckbox: {
    height: '80%',
    width: '80%',
    padding: 0
  },
  comfortableBadge: {
    height: 34
  },
  defaultBadge: {
    height: 28
  },
  compactBadge: {
    height: 22
  },
  comfortableCell: {
    padding: '4px 56px 4px 12px'
  },
  defaultCell: {
    padding: '4px 34px 4px 4px'
  },
  compactCell: {
    padding: '2px 12px 2px 8px'
  },
  comfortableCheckboxCell: {
    padding: '4px 56px 4px 0px'
  },
  defaultCheckboxCell: {
    padding: '4px 34px 4px 0px'
  },
  compactCheckboxCell: {
    padding: '2px 12px 2px 0px'
  }
};
